import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PubSub from 'pubsub-js';
import {AvFeedback, AvForm, AvInput} from 'availity-mobx-reactstrap-validation';

import Backdrop from 'js/components/core/Backdrop';
import ContinueButton, { buttonHeight } from 'js/components/core/SteppedPage/ContinueButton';
import AppContent from "js/components/AppContent";

import Modal from 'js/components/core/Modal';
import LoginSignupDialog from 'js/components/common/LoginSignupDialog';

import Title from './Title';
import LockIcon from './LockIcon';
import Container from './Container';
import AddressInput from "js/components/common/AddressInput";
import LoginSignupDialogState from "js/stores/LoginSignupDialogState";
import AppUser from "js/stores/AppUser";
import AppState from "js/stores/AppState";
import analytics from "js/services/Analytics";
import GoogleAuth from "js/services/auth-driver/GoogleAuth";
import SubTitle from "js/components/common/LoginSignupDialog/SubTitle";
import WelcomeBackMessage from "js/components/common/LoginSignupDialog/WelcomeBackMessage";
import FacebookConnectButton from "js/components/common/LoginSignupDialog/FacebookConnectButton";
import {GoogleLogin} from "react-google-login";
import GoogleConnectButton from "js/components/common/LoginSignupDialog/GoogleConnectButton";
import SocialNetworkConnectError from "js/components/common/LoginSignupDialog/SocialNetworkConnectError";
import Or from "js/components/common/LoginSignupDialog/Or";
import Login from "js/components/common/LoginSignupDialog/Login";
import Signup from "js/components/common/LoginSignupDialog/Signup";
import TermsOfService from "js/components/common/LoginSignupDialog/TermsOfService";
import SwitchDialog from "js/components/common/LoginSignupDialog/SwitchDialog";
import SafariWarning from "js/components/common/LoginSignupDialog/SafariWarning";
import {navigate, url} from "js/services/Network";
import AvGroup from "js/components/pages/BuyerSignupPage/FullName/NameEntry/FullNameInput/AvGroup";
import userCountry from "js/services/UserCountry";

const noop = () => null;

@inject('page')
@observer
export default class SignupSignIn extends Component {
  loginSignupDialog = LoginSignupDialogState.create();
  wasLoggedIn = false;

  static defaultProps = {
    facebook: true,
    google: true,
    singleUseToken: null,
    mseller: false,
  };
  closeModal = () => window.history.back();

  redirect = () => navigate(url('my-tokens-page'));

  pageEvent = () => {
    if (AppUser.isLoggedIn) {
      this.redirect();
    }
  };

  componentDidMount() {
    PubSub.publishSync('canReboot', false);
    this.props.showForm && this.loginSignupDialog.setShowForm(this.props.showForm);
    this.wasLoggedIn = AppUser.isLoggedIn;
    this.wasLoggedIn && this.runAfterTask();
  }
  componentWillUnmount() {
    PubSub.publishSync('canReboot', true);
    AppState.setDialogProps({});
  }

  beforeConnect = () => this.loginSignupDialog.clearError() && (this.props.before || noop)();
  runAfterTask = () => (this.props.afterLogin || this.props.after || noop)();

  onGoogleConnect = response => {
    let tracking;
    if (!response) {
      console.log("no response");
      return;
      // this.beforeConnect();
    }

    analytics.identify(response);

    const prefix = analytics.loginPrefix();

    if (response.is_new_user) {
      tracking = analytics
        .track(`${prefix}account_created_google`, {
          'Email': response.email,
          'Signup Method': 'Google',
          'Name': "",
          'Address': "",
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : 'create-link',
          'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
            ? 'seller' : 'buyer'
        });
    } else {
      tracking = analytics
        .track(`${prefix}logged_in_google`, {
          'Email': response.email,
          'Signup Method': 'Google',
          'Name': "",
          'Address': "",
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
          'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
            ? 'seller' : 'buyer'
        });
    }
    analytics.track('CTA_Engaged_User', {
      'Email': response.email,
      'Signup/Login Method': 'Google',
      'Date': new Date().toString(),
      'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
      'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
        ? 'seller' : 'buyer'
    })
    return tracking.then(this.runAfterTask);
  };

  googleOnSuccess = (response) => {
    try {
      GoogleAuth
        .loginDirect(response.accessToken, {
          single_use_token: this.props.singleUseToken,
          mseller: this.props.mseller
        })
        .then(response => {
          AppUser.handleResponse('google', response);
          return response;
        })
        .then(this.onGoogleConnect)
    } catch (error) {
      throw error;
    }
  }

  render() {
    const page = this.props.page;

    const { showForm, setError, error, toggleDisplay, closeSafariWarning } = this.loginSignupDialog;
    const before = this.props.before || noop;

    const {
      after,
      predicate,
      signupTitle,
      signupText,
      loginTitle,
      loginText,
      loginButtonLabel,
      signupButtonLabel,
      facebookButtonLabel,
      googleButtonLabel,
      termsOfService,
      padded,
      facebook,
      google,
      marketing,
      singleUseToken,
      mseller,
      showForgotPassword,
      showButtonsOnly,
    } = this.props;
    let title = null;
    let subTitle = null;
    if (loginTitle && showForm === 'login') {
      title = <Title>{loginTitle}</Title>;
      if (loginText) {
        subTitle = <SubTitle>{loginText}</SubTitle>;
      }
    } else if (signupTitle && showForm === 'signup') {
      title = <Title>{signupTitle}</Title>;
      if (signupText) {
        subTitle = <SubTitle>{signupText}</SubTitle>;
      }
    }

    const buttonOffset = buttonHeight / 2;
    const contentOffset = !page.hasEnteredFullName ? `${buttonOffset + 1.5}rem` : `${buttonOffset}rem`;
    const step1Img = '/images/v2/sellers/rectangle-horizontal.png';
    const step2Img = '/images/v2/sellers/rectangle-horizontal.png';
    const step3Img = '/images/v2/sellers/rectangle-horizontal.png';
    return (


      <>
        <AppContent className="seller-items-page tw-bg-white" padded>
          <Backdrop offset={contentOffset}>
            <div className="pod-container" style={{padding: "0 1.5rem"}}>
              <div className="tw-flex tw-flex-wrap justify-content-between tw-w-full tw-gap-4 tw-mt-4 tw-mb-3">
                <div className="tw-lg-w-1/2 tw-flex-start tw-flex-auto">
                  <div className="tw-flex tw-mb-8">
                    <span>
                        <div className="tw-flex tw-gap-2 justify-content-between">
                        <span>
                          <img
                            src={`${step1Img}`}
                            alt="step 1"
                            style={{height:'4px', width:'90%'}}
                            className="tw-h-[4px] tw-w-[90%]"
                          />
                        </span>
                        <span>
                        <img
                          src={`${step2Img}`}
                          alt="step 2"
                          style={{height:'4px', width:'90%'}}
                          className="md:tw-hidden tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        <img
                          src={`${step2Img}`}
                          alt="step 2"
                          style={{height:'4px', width:'155.67px'}}
                          className="tw-hidden md:tw-block tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        </span>
                        <span>
                        <img
                          src={`${step3Img}`}
                          alt="step 3"
                          style={{height:'4px', width:'90%'}}
                          className="md:tw-hidden tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        <img
                          src={`${step3Img}`}
                          alt="step 3"
                          style={{height:'4px', width:'155.67px'}}
                          className="tw-hidden md:tw-block tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        </span>
                        </div>
                      </span>
                  </div>
                  <span className="flex-start" style={{font:'inter', fontWeight:'700', fontSize:'17px', lineHeight:'27px'}}>{AppUser.isLoggedIn?'Phone number':'Sign Up'}</span>
                  <div className="md:tw-pr-10 tw-mt-8">
                    { AppUser.isLoggedIn ? (
                      // <div className="md:tw-pr-10 tw-mt-8">
                      //   <WelcomeBackMessage />
                      // </div>
                      <div className="md:tw-pr-10 tw-mt-8">
                        <AvForm onValidSubmit={page.nextDetail}>
                          <AvGroup className="tw-w-full tw-mt-8">
                            <span style={{textAlign:'left',fontWeight:500}}>WhatsApp number</span>
                            <div className="row">
                              <div className="col-3">
                                <AvInput
                                  type="text"
                                  name="prefix"
                                  id="tw-prefix"
                                  value={userCountry === 'US'?'+1':'+234'}
                                  aria-describedby="tw-helper-text-explanation"
                                  className="tw-bg-white tw-text-center tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                                  disabled
                                />
                              </div>
                              <div className="col-9">
                                <AvInput
                                  type="text"
                                  name="phone_number"
                                  value={page.phone_number}
                                  id="tw-phone"
                                  maxLength="10" pattern="\d{10}"
                                  onChange={page.setPhoneNumber}
                                  required
                                  aria-describedby="tw-helper-text-explanation"
                                  className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                                  placeholder={"8069012345"}
                                />
                              </div>
                            </div>
                            <AvFeedback>Please enter your valid whatsapp number</AvFeedback>
                          </AvGroup>
                          <ContinueButton flat onClick={page.nextStep} disabled={!page.phone_number.length} />
                          <span className="tw-mt-5" style={{background: '#F1F0FF'}}>
                            <span style={{padding: '10px'}}>
                              <img
                                src="/images/v2/essential.png"
                                alt="items"
                                className="size-18px"
                              />&nbsp;
                              Your WhatsApp number is needed for order notification
                            </span><br/>
                            <span style={{padding: '28px'}}>and delivery pickup purposes.</span><br/>
                            <span style={{padding: '28px'}}>This number will not be made public.</span>
                          </span>
                        </AvForm>

                      </div>
                    ) : (
                    <Container padded={padded}>
                      {title}
                      {subTitle}

                      {(facebook) && (
                        <div className="md:tw-pr-10 tw-mt-8">
                          <FacebookConnectButton
                            onConnect={this.runAfterTask}
                            onError={setError}
                            beforeConnect={this.beforeConnect}
                            predicate={predicate}
                            page={page}
                            mseller={mseller}
                            addParams={{
                              single_use_token: singleUseToken,
                              mseller: mseller,
                            }}
                          >
                            {facebookButtonLabel}
                          </FacebookConnectButton>
                        </div>
                      )}

                      {(google) && (
                        <div className="md:tw-pr-10 tw-mt-8">
                          <GoogleLogin
                            clientId={window.app.googleSignInClientId}
                            render={renderProps => (
                              <GoogleConnectButton
                                id="gSignInWrapper"
                                callParentClick={renderProps.onClick}
                                page={page}
                                mseller={mseller}
                              >
                                {googleButtonLabel}
                              </GoogleConnectButton>
                            )}
                            onSuccess={this.googleOnSuccess}
                            onFailure={(error) => console.log('error', error)}
                            cookiePolicy={'single_host_origin'}
                          />
                        </div>
                      )}

                      <SocialNetworkConnectError error={error} />

                      {((google || facebook) && showButtonsOnly === undefined) && (
                        <div className="md:tw-pr-10 tw-mt-8">
                          <Or />
                        </div>
                      )}


                      {showForm === 'signup' && !AppUser.isLoggedIn && showButtonsOnly === undefined ?  (
                        <div className="md:tw-pr-10 tw-mt-8">
                          <Login
                            predicate={predicate}
                            before={() => before('Login And Pay')}
                            after={this.runAfterTask}
                            submitLabel={loginButtonLabel}
                            page={page}
                            token={singleUseToken}
                            mseller={mseller}
                            showForgotPassword={showForgotPassword === undefined ? true : showForgotPassword}
                          />
                        </div>

                      ) : showButtonsOnly === undefined && !AppUser.isLoggedIn ? (
                        <div className="md:tw-pr-10 tw-mt-8">
                          <Signup
                            predicate={predicate}
                            before={() => before('Signup And Pay')}
                            after={after}
                            submitLabel={signupButtonLabel}
                            referral={this.props.referral}
                            page={page}
                            marketing={marketing}
                          />
                        </div>
                      ) : (
                          <div className="md:tw-pr-10 tw-mt-8">
                            <AvForm onValidSubmit={page.nextDetail}>
                              <AvGroup className="tw-w-full tw-mt-8">
                                <Title>WhatsApp number</Title>
                                <div className="row">
                                  <div className="col-3">
                                    <AvInput
                                      type="text"
                                      name="prefix"
                                      id="tw-prefix"
                                      value={userCountry === 'US'?'+1':'+234'}
                                      aria-describedby="tw-helper-text-explanation"
                                      className="tw-bg-white tw-text-center tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                                      disabled
                                    />
                                  </div>
                                  <div className="col-9">
                                    <AvInput
                                      type="text"
                                      name="phone_number"
                                      value={page.phone_number}
                                      id="tw-phone"
                                      maxLength="10" pattern="\d{10}"
                                      onChange={page.setPhoneNumber}
                                      required
                                      aria-describedby="tw-helper-text-explanation"
                                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                                      placeholder={"8069012345"}
                                    />
                                  </div>
                                </div>
                                <AvFeedback>Please enter your valid whatsapp number</AvFeedback>
                              </AvGroup>
                              <ContinueButton flat onClick={page.nextStep} disabled={!page.phone_number.length} />
                            </AvForm>
                          </div>
                      )}

                      {termsOfService && <TermsOfService />}


                      <Modal showModal={this.loginSignupDialog.safariWarning} onCancel={closeSafariWarning} withCloseButton>
                        <SafariWarning state={this.loginSignupDialog} />
                      </Modal>
                    </Container>
                    )}




                    {/*<AvForm onValidSubmit={page.nextDetail}>*/}

                    {/*  <div className="tw-mt-7">*/}
                    {/*    <ContinueButton flat onClick={page.nextStep} disabled={!page.address.address1} />*/}
                    {/*    /!*<ContinueButton children={'Proceed'} onClick={page.nextStep} disabled={!page.address.address1} >Continue</ContinueButton>*!/*/}
                    {/*  </div>*/}
                    {/*</AvForm>*/}

                  </div>
                </div>
                <div className="tw-lg-w-1/2 tw-flex-auto">
                  <div className="tw-hidden md:tw-block tw-w-full tw-h-full" style={{height:'100%'}}>
                    <img
                      src="/images/v2/buyers/buyer-signup1.png"
                      alt="Shop with confidence"
                      style={{height:'742px'}}
                      className="tw-h-[742px] tw-w-full"
                    />
                  </div>
                  <div className="tw-block md:tw-hidden tw-w-full tw-h-full" style={{height:'100%'}}>
                    <img
                      src="/images/v2/buyers/buyer-signup2.png"
                      alt="Shop with confidence"
                      style={{height:'517px'}}
                      className="tw-h-[517px] tw-w-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Backdrop>
        </AppContent>



      </>
    );
  }
}





